export function getReadableId(id) {
  return `DSS-${id.toString().padStart(4, '0')}`;
}
